"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../theme"));
const useStyles = (0, _styles.makeStyles)({
  backdrop: {
    zIndex: _theme.default.zIndex.drawer + 1,
    color: '#fff',
    backgroundColor: 'rgba(255,255,255, 0.75)'
  },
  loaderLogo: {
    position: 'absolute',
    animation: "$fadeLogo 1200ms infinite ".concat(_theme.default.transitions.easing.easeInOut)
  },
  circularLoader: {
    color: '#001871'
  },
  '@keyframes fadeLogo': {
    '0%': {
      opacity: 1
    },
    '50%': {
      opacity: 0
    },
    '100%': {
      opacity: 1
    }
  }
});
var _default = exports.default = useStyles;